import Link from 'next/link';
import { useState } from 'react';
import FormMagicLinkRequest from 'src/screens/magic-link/components/MagicLinkRequestForm';
import BackgroundImageLayout from 'src/shared-components/Layout/BackgroundImageLayout';

const RequestMagicLink = () => {
  const [requestSuccessful, setRequestSuccessful] = useState<boolean>(null);

  return (
    <BackgroundImageLayout backgroundImage="bg-apply">
      <div>
        <h1 className="text-2xl font-bold text-center">Request Magic Link</h1>
        <div className="mt-8">
          {requestSuccessful === true && (
            <div className="text-center">
              Please check your email. We sent you a magic link so you can easily get back into Huddle 😊.
            </div>
          )}
          {requestSuccessful === false && (
            <div className="text-center">
              You have not been approved into Huddle yet, you will receive an email when we let you in 😊.
            </div>
          )}
          {requestSuccessful === null && <FormMagicLinkRequest onRequestSent={setRequestSuccessful} />}
        </div>
      </div>

      <div className="text-xs text-center w-4/5	m-auto mt-8">
        Do you remember your password?{' '}
        <Link href="/signin">
          <a className="font-bold"> Sign in</a>
        </Link>
      </div>
    </BackgroundImageLayout>
  );
};

export default RequestMagicLink;
